export enum TransactionType {
    EQ = 'EQ',
    FX = 'FX',
    FU = 'FU'
}